<template>
    <div class="modal-out">
        <div class="modal">
            <div class="modal-header">
                <div class="title">添加</div>
                <button type="button" class="btn-close" @click="closeSelf">X</button>
            </div>
            <div class="modal-body">

                <el-form :model="addForm" :rules="rules" ref="addForm">

                  <el-row>
                    <el-col :span="12" class="item">
                      <el-form-item label="机构" required prop="institutionCode">
                        <el-select v-model="addForm.institutionCode" placeholder="请选择机构" style="width: 100%">
                          <el-option
                              v-for="item in arr_ins"
                              :key="item.institutionCode"
                              :label="item.userName"
                              :value="item.institutionCode">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                      <el-col :span="12" class="item">
                          <el-form-item label="名称" required prop="name">
                              <el-input v-model="addForm.name" placeholder="请输入名称"></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="12" class="item">
                          <el-form-item label="排序" required prop="sort">
                              <el-input v-model.number="addForm.sort" placeholder="请输入排序"></el-input>
                          </el-form-item>
                      </el-col>
                  </el-row>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'Add',
      props:["arr_ins"],
        data() {
            return {

                loading: false,

                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                  institutionCode:'',
                    name:'',
                    sort:'',
                },

                rules:{
                    name:[
                        { required: true, message: '请输入名称', trigger: 'blur' },
                    ],
                    sort:[
                        { required: true, message: '请输入排序', trigger: 'blur' },
                        { type: 'number', message: '排序必须为数字值'}
                    ],
                  institutionCode:[
                    { required: true, message: '请选择机构', trigger: 'blur' },
                  ],

                }


            }
        },

        methods: {
            init(){

                this.$refs.addForm.resetFields();


            },
            closeSelf() {
                this.$emit("closeAdd");
            },


            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },

            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Warehouse/GovAddIns",
                    data: this.addForm
                }).then((response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeAdd");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    })
            },


        }
    }


</script>





<style lang="scss" scoped>


</style>
